import { AuthShowcasePanel } from "@/shared/components/authShowcase/AuthShowcasePanel";

const BRAND_COPY = {
  TITLE_LINES: ["Votre CSE.", "Vos avantages."],
  TITLE_ACCENT: "Et vous.",
} as const;

export const LoginBrandPanel = () => (
  <AuthShowcasePanel titleLines={BRAND_COPY.TITLE_LINES} titleAccent={BRAND_COPY.TITLE_ACCENT} />
);

LoginBrandPanel.displayName = "LoginBrandPanel";
